export interface IReportAdmin {
  name: string;
  type: string;
  active: boolean;
  roles: string[];
}

export const REPORT_DATA: IReportAdmin[] = [
  {
    name: 'Sales Profit',
    type: 'sales_profit',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'AP Aging',
    type: 'ap_aging',
    active: true,
    roles: ['super_admin', 'account_receivable']
  },
  {
    name: 'AR Aging',
    type: 'ar_aging',
    active: true,
    roles: ['super_admin', 'account_receivable']
  },
  {
    name: 'Short Pays',
    type: 'short_pays',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Credit Card',
    type: 'credit_card',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Commission',
    type: 'comission_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'New Commission',
    type: 'comission_report_new',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'damage Commission',
    type: 'comission_report_damage',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Credit Card Carrier',
    type: 'credit_card_carrier',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Daily cash received summary',
    type: 'daily_cash_summary',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Daily cash received details',
    type: 'daily_cash_detail',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Dispatch report',
    type: 'dispatch_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Winback report',
    type: 'winback_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Speed pay Report',
    type: 'speed_pay',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Speed pay sent Report',
    type: 'speed_pay_sent',
    active: true,
    roles: ['super_admin', 'account_receivable']
  },
  {
    name: 'Orders report',
    type: 'orders_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Damaged Orders',
    type: 'orders_report',
    active: true,
    roles: ['super_admin', 'account_receivable'],
  },
  {
    name: 'Tier 1 report',
    type: 'tier1_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Tier 2 report',
    type: 'tier2_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Tier 3 report',
    type: 'tier3_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Tier 4 report',
    type: 'tier4_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'ETA report',
    type: 'eta_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'In-Transit report',
    type: 'intransit_report',
    active: true,
    roles: ['super_admin']
  },
  {
    name: 'Delivery Report',
    type: 'delivery_report',
    active: true,
    roles: ['super_admin']
  },
];

export const REPORT_DATA_ACCOUNT_PAYABLE: IReportAdmin[] = [
  {
    name: 'AP Aging',
    type: 'ap_aging',
    active: true,
    roles: ['account_payable']
  }
];
